import { StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";

import { Record } from "../../../records/server/crud";

export class WebJobDetailController implements IOnInit {
  static $inject = ["$state"];
  webJobDetail!: Record;
  
  
  constructor(
    private readonly $state: StateService
  ) {}

  $onInit(): void {
    
  }
  detailPage(machineId: number) {
    this.$state.go("main.machines.detail.configurations", { machineId });
  }
}
